import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import {
  DeleteMenuItemWithConfirmationModal,
  DeleteMenuItemWithConfirmationModalProps,
} from '@/components/poppers/MenuPopper/DeleteMenuItemWithConfirmationModal';
import { useReportError } from '@/hooks/useReportError';

import { useDeleteLiabilityMutation } from '../LiabilityModal/graphql/LiabilityModal.generated';

interface DeleteLiabilityMenuItemProps
  extends Partial<DeleteMenuItemWithConfirmationModalProps> {
  liabilityId: string;
  onDelete: () => void;
  modalProps?: Record<string, unknown>;
  menuItemProps?: Record<string, unknown>;
}

export function DeleteLiabilityMenuItem({
  liabilityId,
  onDelete,
  modalProps = {},
  menuItemProps = {},
  ...deleteProps
}: DeleteLiabilityMenuItemProps) {
  const { showFeedback } = useFeedback();
  const { reportError } = useReportError();

  const [deleteLiability, { loading: deleting }] = useDeleteLiabilityMutation({
    variables: { liabilityId },
    onError: (error) => {
      reportError(`Failed to delete liability`, error);
      showFeedback(
        'Failed to delete this liability. Please refresh the page and try again.'
      );
    },
    onCompleted: () => {
      showFeedback('Liability deleted successfully', { variant: 'success' });
      onDelete();
    },
  });

  return (
    <DeleteMenuItemWithConfirmationModal
      label="Delete liability"
      onConfirmDelete={() => deleteLiability()}
      {...deleteProps}
      menuItemProps={{ loading: deleting, ...menuItemProps }}
      modalProps={{
        heading: 'Are you sure you want to delete this liability?',
        ...modalProps,
      }}
    />
  );
}
